import { createContext, useCallback, useContext, useEffect, useState, type ReactNode } from 'react';
import { employeeApi } from '../../lib/api';

interface EmployeeData {
  employee: any;
  consent: any;
  signature: any;
  documentPhoto: any;
  profilePhotoUrl: string | null;
  termoTexto: string;
  toleranciaMin: number;
  tipoHorario: 'esperado' | 'turno' | 'manual';
  turnoDiurno: { entrada: string } | null;
  turnoNoturno: { entrada: string } | null;
  vtValorPadrao: string | null;
  vtDataPadrao: string | null;
}

interface EmployeeContextValue extends EmployeeData {
  loading: boolean;
  refresh: () => Promise<EmployeeData>;
}

const EmployeeContext = createContext<EmployeeContextValue | null>(null);

export function EmployeeProvider({ children }: { children: ReactNode }) {
  const [data, setData] = useState<EmployeeData | null>(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    const res = await employeeApi.me() as EmployeeData;
    setData(res);
    return res;
  }, []);

  useEffect(() => {
    (async () => {
      setLoading(true);
      await refresh();
      setLoading(false);
    })();
  }, [refresh]);

  if (loading || !data) {
    return <div className="login-wrap"><p className="muted">Carregando…</p></div>;
  }

  return (
    <EmployeeContext.Provider value={{ ...data, loading, refresh }}>
      {children}
    </EmployeeContext.Provider>
  );
}

export function useEmployee(): EmployeeContextValue {
  const ctx = useContext(EmployeeContext);
  if (!ctx) throw new Error('useEmployee must be used within EmployeeProvider');
  return ctx;
}
